export const CricketGenRules = [
  {
    category: 'MATCH ODDS',
    rules: [
      'Match Odds & Book Maker Market Will Suspend If Play Stop On Rain Or Any Other Technical Reasons..',
      "At the Moment of the Third Umpire Decision We Can't Accept Bets in Any Fancy and Match Odds",
    ],
  },
  {
    category: 'FANCY',
    rules: [
      'All fancy bets will be validated when match has been tied.',
      'All advance fancy will be suspended before toss or weather condition.',
      'In case technical error or any circumstances any fancy is suspended and does not resume result will be given all previous bets will be valid.',
      'If any case wrong rate and wrong commentary has been given in fancy that particular bets will be cancelled.',
      'In any circumstances management decision will be final related to all exchange items.',
      'In case customer make bets in wrong fancy we are not liable to delete, no changes will be made and bets will be consider as confirm bet.',
      'Due to any technical error market is open and result has come all bets after result will be deleted.',
      'Four, sixes, wide, wicket, extra run, total run, highest over and top batsman, maiden over, caught-out, no-ball, run-out, fifty and century are valid only match has been completed in case due to rain over has been reduced all other fancy will be deleted. All complete events are valid E.x 1 over run team A etc.. .',
      'Penalty runs will not be counted in any fancy.',
      'Due to mistakes in official scorecard our scorecard and results will be valid.',
      'Our exchange is not responsible for misuse of client id,master account and super master account.',
      'Minimum number of legal over has to be bowled by the bowler mentioned in the event, else the same will not be considered as valid.',
    ],
  },
  {
    category: 'PLAYER BOOKMAKER',
    rules: [
      'Suppose Either No1 Or No2 Player Score Compare To Run But Which Even IS Hire Score IS Win',
      'Explanation Of Player Bookmaker: Compare Both Player Runs At Wicket ..if V kohli Runs 22 and R.Sharma Run 20 At The Moment Of WICKET Then V KOHLI will BE Winner.',
      "If Both Player Score Is Level It's Means Virat Kohli & Rohit Sharma Both Are Either Out Match Over Is Complete, It's Mean Game Is Tie",
      'If Match Are Interpreted Due To Bed Weather Or Any Thing Else At That Time Low Score Player Run Are Not Count And Match Are Declared To ABANDONED',
    ],
  },
  {
    category: 'Other Fancy',
    rules: [
      'T-20 ,one day and test match in case current innings player and partnership are running in between match has been called off or abandoned that situation all current player and partnership results are valid.',
      '1st wicket lost to any team balls meaning that any team 1st wicket fall down in how many balls that particular fancy at least minimum one ball have to be played otherwise bets will be deleted.',
      '1st wicket lost to any team fancy valid both innings.',
      'How many balls for 50 runs any team meaning that any team achieved 50 runs in how many balls that particular fancy at least one ball have to be played otherwise that fancy bets will be deleted',
      'How many balls for 50 runs fancy any team only first inning valid.',
      'How many balls face any batsman meaning that any batsman how many balls he/she played that particular fancy at least one ball have to be played otherwise that fancy bets will be deleted.',
      'How many balls face by any batsman both innings valid.',
    ],
  },
];

export const TestMachRules = [
  {
    category: 'Session',
    rules: [
      'Complete session valid in test.',
      'Session is not completed for ex:- India 60 over run session Ind is running in case India team declares or all-out at 55 over next 5 over session will be continue in England inning.',
      '1st day 1st session run minimum 25 over will be played then result is given otherwise 1st day 1st session will be deleted.',
      '1st day 2nd session run minimum 25 over will be played then result is given otherwise 1st day 2nd session will be deleted',
      '1st day total run minimum 80 over will be played then result is given otherwise 1st day total run will be deleted',
      'Test match both advance session is valid.',
    ],
  },
  {
    category: 'Test lambi/ Inning run',
    rules: [
      'Mandatory 70 over played in test lambi paari/ Innings run. If any team all-out or declaration lambi paari/ innings run is valid',
      '2 In case due to weather situation match has been stopped all lambi trades will be deleted.',
      'In test both lambi paari / inning run is valid in advance fancy.',
    ],
  },
  {
    category: 'Test batsman',
    rules: [
      'In case batsmen is injured he/she is made 34 runs the result will be given 34 runs.',
      'Batsman 50/100 run if batsman is injured or declaration the result will be given on particular run.',
      'In next men out fancy if player is injured particular fancy will be deleted.',
      'In advance fancy opening batsmen is only valid if same batsmen came in opening the fancy will be valid in case one batsmen is changed that particular player fancy will be deleted.',
      'Test match both advance fancy batsmen run is valid.',
    ],
  },
  {
    category: 'Other fancy advance',
    rules: [
      'Four, sixes, wide, wicket, extra run, total run, highest over and top batsmen is valid only if 300 overs has been played or the match has been won by any team otherwise all these fancy will be deleted.',
    ],
  },
  {
    category: 'Concussion in Test',
    rules: [
      'All bets of one over session will be deleted in test scenario, in case session is incomplete. For example innings declared or match suspended to bad light or any other conditions.',
    ],
  },
  {
    category: 'Total Match- Events (Test)',
    rules: [
      'Minimum of 300 overs to be bowled in the entire test match, otherwise all bets related to the particular event will get void. For example, Total match caught outs will be valid only if 300 overs been bowled in the particular test match',
    ],
  },
];

export const T20MatchRules = [
  {
    category: 'Session',
    rules: [
      'Match 1st over run advance fancy only 1st innings run will be counted.',
      'For example:- 35 over run team a is playing any case team A is all-out in 33 over team a has made 150 run the session result is validated on particular run.',
      'Advance session & All Fancy is valid in only 1st innings',
    ],
  },
  {
    category: '50 over runs',
    rules: [
      'In case 50 over is not completed all bet will be deleted due to weather or any condition.',
      'Advance 50 over runs is valid in only 1st innings.',
    ],
  },
  {
    category: 'Odi / T20 batsman runs',
    rules: [
      'In case batsman is injured he/she is made 34 runs the result will be given 34 runs.',
      'In next men out fancy if player is injured particular fancy will be deleted.',
      'In advance fancy opening batsmen is only valid if same batsmen came in opening the fancy will be valid in case one batsmen is changed that particular player fancy will be deleted.',
    ],
  },
  {
    category: 'T20 over runs',
    rules: [
      'Advance 20 over run is valid only in 1st innings. 20 over run will not be considered as valid if 20 overs is not completed due to any situation.',
    ],
  },
  {
    category: 'T20 / ODI batsman runs',
    rules: [
      'In case batsman is injured he/she is made 34 runs the result will be given 34 runs.',
      'In next men out fancy if player is injured particular fancy will be deleted.',
      'In advance fancy opening batsmen is only valid if same batsmen came in opening the fancy will be valid in case one batsmen is changed that particular player fancy will be deleted.',
    ],
  },
  {
    category:
      "At the Moment of the Third Umpire Decision We Can't Accept Bets in Any Fancy and Match Odds.",
    rules: [],
  },
];

export const CricketCheeting = [
  {
    category: 'Cheating',
    rules: [
      'Cheating Of Any Kind Is Not Allowed And Customers Bets Who Are Deemed To Be Cheating Are Liable To Have Bets Made Void. Cheating Includes But Is Not Limited To; Market Price Manipulation, Court Siding, Sniping And Commission Abuse.',
      'The Site Reserves The Right To Void Any Bets That Are Under Review As Part Of Any Integrity Investigation.',
      'The Site May Void Certain Bets In A Market Or Void A Whole Market In Its Entirety As A Result Of Any Integrity Investigation.',
      "The Site's Decision In Such Integrity Cases Shall Be ﬁnal And Binding Upon The Customer.",
      'Customers Using VPN Applications To Mask Location Or Proxy Servers To Mask Device Are Liable To Having Bets Invalidated. Customers Appearing From Multiple IP Locations Are Also Liable To Having Bets Invalidated.',
    ],
  },
];

export const RulesOfTennis = [
  {
    category: 'Rules Of Tennis',
    rules: [
      'All Bets Will Stand Irrespective Of A Change Of Schedule (Or Day Of Match).',
      'All Bets Will Be Void In The Event Of A Match Starting But Not Being Completed, Except For Bets Where The Outcome Has Already Been Determined. For Example - A Game Is Abandoned At 6-4, 5-1. In This Instance.',
      'Bets On The First Set Winner Will Be Finalized As A Winner. The Only Exception To This Rule Is Where A Player Is Disqualified, After Which The Player Or Team Progressing To The Next Round Will Be Deemed The Winner.All Games Result Given By Trusted Scoring Sites And Live Tv Reference.',
      'Trading bet will not consider in our exchange.',
      'All tennis events will be settled and winner will be declared after 1st set is completed. All bets will be voided if any player retried/walkover in between 1st set or before event starts.',
      'Bet will be void any time from our system.',
    ],
  },
  {
    category: 'Cheating',
    rules: [
      'Cheating Of Any Kind Is Not Allowed And Customers Bets Who Are Deemed To Be Cheating Are Liable To Have Bets Made Void. Cheating Includes But Is Not Limited To; Market Price Manipulation, Court Siding, Sniping And Commission Abuse.',
      'The Site Reserves The Right To Void Any Bets That Are Under Review As Part Of Any Integrity Investigation.',
      'The Site May Void Certain Bets In A Market Or Void A Whole Market In Its Entirety As A Result Of Any Integrity Investigation.',
      "The Site's Decision In Such Integrity Cases Shall Be ﬁnal And Binding Upon The Customer.",
      'Customers Using VPN Applications To Mask Location Or Proxy Servers To Mask Device Are Liable To Having Bets Invalidated. Customers Appearing From Multiple IP Locations Are Also Liable To Having Bets Invalidated.',
    ],
  },
];

export const RulesOfSoccer = [
  {
    category: 'Rules Of Football',
    rules: [
      'Result Will Be Given On The Basis Of 90+2/4 Minutes.',
      'Match Odds Will Suspend While Penalty Shootout & Extra Time Between Play',
      'Extra Time Goal Is Not Consider In Result',
      '. Abandoned Or Postponed Games Are Void Unless Rearranged And Played In The Same Weekly Schedule Except For Those Bets That Have Already Been Determined At The Time Of Abandonment Or Postponement.',
      'If A Game Venue Is Changed, Bets Already Placed Will Stand, Providing The Home Team Is Still Designated As Such.',
      'If The Home And Away Team For A Listed Game Are Reversed, Then Bets Placed Based On The Original Listing Will Be Void.',
      'In 2-Way Markets Push Rules Apply, Unless Otherwise Stated. Bet Amounts On Straight Bets Are Returned, And In Parlays The Selection Is Treated As A Non-Runner. For Example - In Handicap Or Totals Betting Where The Index (Value) Of The Market Is A Whole Number, Bets Are Void And Will Be Refunded Where The Score Lands On That Number.',
      'For the cancellation of a goal, due to VAR, bets matched between the time of the goal being scored and the time at which the video assistant referee finishes the review will be voided',
      'All Settlements Are Based On Results And Statistics Provided By The Relevant League’s Governing Body:',
      'We Reserve The Right To Suspend Any Or All Betting On A Game At Any Time Without Notice.',
      'For Settlement Purposes, The Team Listed First In The Event Name Is Always Considered The Home Team. Example: Team A Vs Team B - Team A Is The Home Team.',
    ],
  },
  {
    category: 'Cheating',
    rules: [
      'Cheating Of Any Kind Is Not Allowed And Customers Bets Who Are Deemed To Be Cheating Are Liable To Have Bets Made Void. Cheating Includes But Is Not Limited To; Market Price Manipulation, Court Siding, Sniping And Commission Abuse.',
      'The Site Reserves The Right To Void Any Bets That Are Under Review As Part Of Any Integrity Investigation.',
      'The Site May Void Certain Bets In A Market Or Void A Whole Market In Its Entirety As A Result Of Any Integrity Investigation.',
      "The Site's Decision In Such Integrity Cases Shall Be ﬁnal And Binding Upon The Customer.",
      'Customers Using VPN Applications To Mask Location Or Proxy Servers To Mask Device Are Liable To Having Bets Invalidated. Customers Appearing From Multiple IP Locations Are Also Liable To Having Bets Invalidated.',
    ],
  },
];

export const RulesOfBinary = [
  {
    category: 'Binary',
    rules: [
      "All session's bets will be confirmed at the market rate only.",
      "All session's settlement price means results can be checked from the exchange's official sites.",
      'All session results will be the settlement price provided by the exchange after market close.',
      'We provide only the FUTURE price in Binary Session. You can check it from the official website of that product.',
      "Session's timings: NFY, B-NFY - Monday to Friday 10:00 A.M to 2:30 P.M GOLD, SILVER, CRUDE - Monday to Friday 10:30 A.M to 10:30 P.M",
    ],
  },
];

export const FancyGenRules = [
  {
    category: 'FANCY RULES',
    rules: [
      'Once all session/fancy bets are completed and settled there will be no reversal even if the Match is Tied or is Abandoned. • Middle session and Session is not completed due to Innings declared or all out so that particular over considered as completed and remaining over counted in next team Innings for ex:- In case of Innings declared or all out In 131.5th over Considered as 132 over completed remaining 1 over counted for 133 over middle session and 3 over counted for 135 over session from next team Innings and One over session and Only over session is not completed due to innings declared so that Particular over session bets will be deleted and all out considered as valid for ex:- In case of Innings declared In 131.5th over so 132 over will be deleted and if all out then 132 over and Only 132 over will be Valid.',
      ' Advance Session or Player Runs and all Fancy Bets are only valid for 20/50 overs full match each side. (Please Note this condition is applied only in case of Advance Fancy Bets only).• Adv Session Markets is Valid Only for First Innings of the Match',
      'All advance fancy bets market will be suspended 60 mins prior to match and will be settled.',
      'Under the rules of Session/Fancy Bets if a market gets Suspended for any reason whatsoever and does not resume then all previous Bets will remain Valid and become HAAR/JEET bets.',
      'Incomplete Session/Fancy Bet will be cancelled but Complete Session will be settled.',
      'In the case of Running Match getting Cancelled/ No Result/ Abandoned but the session is complete it will still be settled. Player runs / fall of wicket will be also settled at the figures where match gets stopped due to rain for the inning (D/L) , cancelled , abandoned , no result.',
      ' If a player gets Retired Hurt and one ball is completed after you place your bets then all the betting till then is and will remain valid. We Consider Retired Out as Retired Hurt',
      ' Should a Technical Glitch in Software occur, we will not be held responsible for any losses.',
      'Should there be a power failure or a problem with the Internet connection at our end and session/fancy market does not get suspended then our decision on the outcome is final.',
      'All decisions relating to settlement of wrong market being offered will be taken by management. Management will consider all actual facts and decision taken will be full in final.',
      'Any bets which are deemed of being suspicious, including bets which have been placed from the stadium or from a source at the stadium maybe voided at anytime. The decision of whether to void the particular bet in question or to void the entire market will remain at the discretion of Company. The final decision of whether bets are suspicious will be taken by Company and that decision will be full and final.',
      'Any sort of cheating bet , any sort of Matching (Passing of funds), Court Siding (Ghaobaazi on commentary), Sharpening, Commission making is not allowed in Company, If any company User is caught in any of such act then all the funds belonging that account would be seized and confiscated. No argument or claim in that context would be entertained and the decision made by company management will stand as final authority.',
      'Fluke hunting/Seeking is prohibited in Company , All the fluke bets will be reversed. Cricket commentary is just an additional feature and facility for company user but company is not responsible for any delay or mistake in commentary.',
     'Valid for only 1st inning.• Highest Inning Run: This fancy is valid only for the first inning of the match.• Lowest Inning Run: This fancy is valid only for the first inning of the match.',
     'If any fancy value gets passed, we will settle that market after that match gets over. For example :- If any market value is ( 22-24 ) and incase the result is 23 than that market will be continued, but if the result is 24 or above then we will settle that market. This rule is for the following market.• Total Sixes In Single Match• Total Fours In Single Match • Highest Inning Run • Highest Over Run In Single Match• Highest Individual Score By Batsman . Highest Individual Wickets By Bowler',
     'If any fancy value gets passed, we will settle that market after that match gets over. For example :- If any market value is ( 22-24 ) and incase the result is 23 than that market will be continued, but if the result is 22 or below then we will settle that market. This rule is for the following market. *Lowest Inning Run . *Fastest Fifty . *Fastest Century',
     'If any case wrong rate has been given in fancy, that particular bets will be cancelled (Wrong Commentary).',
     ' In case customer make bets in wrong fancy we are not liable to delete, no changes will be made and bets will be considered as confirm bet.',
     'Any cricket event which is being held behind closed doors in that if any players found to be taking advantage of groundline in fancy bets in such cases bets can be voided after the market ends . Company decision to be final .',
     'Company reserves the right to void any bets (only winning bets) of any event at any point of the match if the company believes there is any cheating/wrong doing in that particular event by the players (either batsman/bowler)',
     'In the live match if the match scoreboard change or the TVs scoreboard have any issues, example (scoreboard not showing , team score change at any point), we will declare the result of the fancy based on the rate that we are offering in the live match. The final decision of the result will be taken by the company and that decision will be full and final.',
     'If there is a super over then the match odds of the Super Over will be settled after the Final result of winner team is declared but in case of Bookmaker we will Settle or Void the Particular super over Bookmaker Based upon that Particular Markets Result',
     'We wont consider Retired hurt/Out of any player as a Wicket ..bets will remain valid and gets settled once wicket falls ..for e.g if wicket market is running and player gets retired out/hurt then we will wait for another player to get out for the settlement',
    ],
  },
  {
    category: 'DOT BALL MARKET RULES',
    rules: [
      'Wides Ball - Not Count.',
      'No Ball - Not Count',
      'Leg Bye - Not Count as A Dot Ball',
      'Bye Run - Not Count as A Dot Ball',
      'Run Out - On 1st Run Count as A Dot Ball',
      'Run Out - On 2nd n 3rd Run Not Count as a Dot Ball',
      'Out - Catch Out, Bowled, Stumped n LBW Count as A Dot Ball'
      
    ],
  },
  {
    category: 'BOOKMAKER RULES',
    rules: [
      'Due to any reason any team will be getting advantage or disadvantage we are not concerned.',
      'We will simply compare both teams 25 overs score higher score team will be declared winner in ODI.',
      'We will simply compare both teams 10 overs higher score team will be declared winner in T20 matches.'
    ],
  },
  {
    category: 'PENALTY RUNS',
    rules: [
    'Any Penalty Runs Awarded in the Match (In Any Running Fancy or ADV Fancy) Will Not be Counted While Settling in our Exchange. Exception - Penalty runs will be counted on new offered fancy after getting penalty runs in running match .. for example if penalty given at 8th over and we offered new 15 over market after 8th over ..we will include penalty on that particular market .',
    ],
  },
  {
    category: 'LIVE STREAMING OF ALL VIRTUAL CRICKET MATCHES ',
    rules: [
      "https://www.youtube.com/channel/UCd837ZyyiO5KAPDXibynq_Q/featured"
      
    ],
  },
  {
    category: 'CHECK SCORE OF VIRTUAL CRICKET ON',
    rules: [
      'https://sportcenter.sir.sportradar.com/simulated-reality/cricket',
      
    ],
  },
  {
    category: 'COMPARISON MARKET',
    rules: [
      "In Comparison Market We Don't Consider Tie or Equal Runs on Both the Innings While Settling . Second Batting Team Must need to Surpass 1st Batting's team Total to win otherwise on Equal Score or Below We declare 1st Batting Team as Winner ",

    ],
  },
  {
    category: 'PLAYER BOUNDARIES FANCY ',
    rules: [
      "We will only consider Direct Fours and Sixes hit by BAT.",
      
    ],
  },
  {
    category: 'BOWLER RUN SESSION RULE ',
    rules: [
      "IF BOWLER BOWL 1.1 OVER,THEN VALID ( FOR BOWLER 2 OVER RUNS SESSION )",
      'IF BOWLER BOWL 2.1 OVER,THEN VALID ( FOR BOWLER 3 OVER RUNS SESSION )',
      'IF BOWLER BOWL 3.1 OVER,THEN VALID ( FOR BOWLER 4 OVER RUNS SESSION )',
      'IF BOWLER BOWL 4.1 OVER,THEN VALID ( FOR BOWLER 5 OVER RUNS SESSION )',
      'IF BOWLER BOWL 9.1 OVER,THEN VALID ( FOR BOWLER 10 OVER RUNS SESSION )',
      
    ],
  },
  {
    category: 'TOTAL MATCH PLAYING OVER ADV',
    rules: [
      "We Will Settle this Market after Whole Match gets Completed Criteria :- We Will Count Only Round- Off Over For Both the Innings While Settling (For Ex :- If 1st Batting team gets all out at 17.3 , 18.4 or 19.5 we Will Count Such Overs as 17, 18 and 19 Respectively and if Match gets Ended at 17.2 , 18.3 or 19.3 Overs then we will Count that as 17 , 18 and 19 Over Respectively... and this Will Remain Same For Both the Innings ..",
      'If over Reduces because of rain (either in 1st or 2nd innings), whole market will get voided',
      
    ],
  },
  {
    category: ' 3 WKT OR MORE BY BOWLER IN MATCH ADV',
    rules: [
      "We Will Settle this Market after Whole Match gets Completed" ,
      'In Case Of Rain or if Over Gets Reduced then this Market Will get Voided',
      
    ],
  },
  {
    category: 'KHADDA',
    rules: [
      "ADV Khadda Fancy is Valid Only for First Innings of the Match",
      'In Case of Rain or If Over Gets Reduced then this Market Will get Voided',
      'Incomplete Session Bet will be Cancelled but Complete Session Will be Settled',
      
    ],
  },
  {
    category: 'LOTTERY',
    rules: [
      "In Case of Rain or If Over Gets Reduced then this Market Will get Voided",
      'Incomplete Session Bet will be Cancelled but Complete Session Will be Settled',
      'Criteria :- We will Only Count Last Digit of Sessions Total while settling ..For Example if in 6 Overs Market the Score is 37 ...so we will Settle the Market for 6 Over Lottery @ 7',
      
    ],
  },
  {
    category: 'IPL 2021 RULES',
    rules: [
      'If Over Reduced in Match, we will not count the actual scores of the Over Reduced Matches instead we will count the Market’s Average Scores.',
      'If Match is Abandoned, we will not count the actual scores of the Abandoned Matches instead we will count the Market’s Average Scores.',
      'NOTE: -. These rules are for the following Markets of ENTIRE IPL 2021 {60 Matches}: -',
      'Total Match 1st Over Run :- Average 6 Runs will be given if the match is abandoned or over reduced, But If 1st Over is Completed then it will not be counted as Average Score instead we will count the Actual Score if Over is Reduced after completion of 1st Over.',
      'Total Fours: - Average 26 Fours will be given if the match is abandoned or over reduced.',
      'Total Sixes: - Average 13 Sixes will be given if the match is abandoned or over reduced.',
      'Total Wide: - Average 8 Wide’s will be given if the match is abandoned or over reduced.',
      'Total Extras: - Average 14 Extras will be given if the match is abandoned or over reduced.',
     ' Total No Ball: - Average 1 No Ball will be given if the match is abandoned or over reduced.',
      'Total Duck: - Average 1 Duck will be given if the match is abandoned or over reduced.',
      'Total Fifties: - Average 2 Fifties will be given if the match is abandoned or over reduced.',
'Total Century: -Average 0 Century will be given if the match is abandoned or over reduced.',
'Total Run Out: - Average 1 Run Out will be given if the match is abandoned or over reduced.',
'Total Wickets: - Average 12 Wickets will be given if the match is abandoned or over reduced.',
'Total Caught out: - Average 8 Caught Out will be given if the match is abandoned or over reduced.',
'Total Maiden Over: - Average 0 Maiden Over will be given if the match is abandoned or over reduced.',
'Total LBW: - Average 1 LBW will be given if the match is abandoned or over reduced.',
'Total Bowled: - Average 2 Bowled will be given if the match is abandoned or over reduced.', 
'• In case IPL Matches Gets Stopped or Interrupted Due to "COVID-19" or Any "ACT OF GOD" Reasons, Under 45 Matches then All IPL 2021 Tournament Fancy Markets will be Voided, But if 45 or Above Matches are Being Played then we will Settle all the Fancy Markets and Also If there are NON Played Matches Above 45 then we will settle the markets as per our Markets Average.',
'If IPL 2021 gets stopped due to “Covid-19” or Any “Act of God” reason then We will wait till 45 days from the day IPL gets stopped , and if IPL Matches gets Resumed before 45th day then we will continue as Usual Score Countation but if IPL 2021 does not resumes until 45th day then we will settle the markets according to our above mentioned Markets Averages and In case of Void, We will Void the under 45 matches on 45th day from the day IPL 2021 stopped.',

    ],
  },
  {
    category: 'SESSION ODD EVEN RULE',
    rules: [
      "We Will Settle the Session ODD-EVEN Market only if the Over is Completed, But If that Over is Not Completed then we will Void that “Session Total Odd” Market."
      
    ],
  },
  {
    category: 'TOTAL MATCH 30S',
    rules: [
      "In this market, If player's score between 30 to 49 Runs that will be considered in this Market. If a player reached 50 or above, they aren't considerd in this event."
      
    ],
  },
  {
    category: 'TOTAL OVER RUNS RULE',
    rules: [
      "If over Reduces because of rain (either in 1st or 2nd innings), whole market will get voided",
      'Penalty runs will be counted in this market',
      
    ],
  },
];